// 도메인별로 분리된 번역 파일들을 통합하는 파일
import headerKo from './header/ko.json'
import headerEn from './header/en.json'
import productVideoEditorKo from './productVideoEditor/ko.json'
import productVideoEditorEn from './productVideoEditor/en.json'
import tiktokKo from './tiktok/ko.json'
import tiktokEn from './tiktok/en.json'
import authKo from './auth/ko.json'
import authEn from './auth/en.json'
import challengeKo from './challenge/ko.json'
import challengeEn from './challenge/en.json'
import paybackKo from './payback/ko.json'
import paybackEn from './payback/en.json'
import freePlanKo from './freePlan/ko.json'
import freePlanEn from './freePlan/en.json'
import contentVideoEditorKo from './content-video-editor/ko.json'
import contentVideoEditorEn from './content-video-editor/en.json'
import fastclickKo from './fastclick/ko.json'
import fastclickEn from './fastclick/en.json'
import guideToUseKo from './guideToUse/ko.json'
import guideToUseEn from './guideToUse/en.json'
import videoTypesKo from './videoTypes/ko.json'
import videoTypesEn from './videoTypes/en.json'
import footerKo from './footer/ko.json'
import footerEn from './footer/en.json'

// 기존 파일에서 나머지 섹션들을 임시로 가져오기 (추후 분리 예정)
import originalKo from './ko.json'
import originalEn from './en.json'

// 한국어 번역 통합 (기존 구조 유지 + 새로운 도메인별 구조 추가)
export const koTranslations = {
  // 기존 구조 유지 (하위 호환성)
  common: originalKo.common,
  header: headerKo, // 새로운 분리된 header 사용
  video: originalKo.video,
  payment: originalKo.payment,
  errors: originalKo.errors,
  home: originalKo.home,
  faq: originalKo.faq,
  videoUsageHistory: originalKo.videoUsageHistory,
  contentVideoEditor: contentVideoEditorKo, // 새로운 분리된 contentVideoEditor 사용
  planDashboard: originalKo.planDashboard, // Plan 컴포넌트 번역 추가
  productVideoEditor: productVideoEditorKo, // 새로운 분리된 productVideoEditor 사용
  tiktok: tiktokKo, // 새로운 분리된 tiktok 사용
  auth: authKo, // 새로운 분리된 auth 사용
  challenge: challengeKo, // 새로운 분리된 challenge 사용
  payback: paybackKo, // 새로운 분리된 payback 사용
  freePlan: freePlanKo, // 새로운 분리된 freePlan 사용
  fastclick: fastclickKo, // 새로운 분리된 fastclick 사용
  guideToUse: guideToUseKo, // 새로운 분리된 guideToUse 사용
  videoTypes: videoTypesKo, // 새로운 분리된 videoTypes 사용
  footer: footerKo, // 새로운 분리된 footer 사용
}

// 영어 번역 통합 (기존 구조 유지 + 새로운 도메인별 구조 추가)
export const enTranslations = {
  // 기존 구조 유지 (하위 호환성)
  common: originalEn.common,
  header: headerEn, // 새로운 분리된 header 사용
  video: originalEn.video,
  payment: originalEn.payment,
  errors: originalEn.errors,
  home: originalEn.home,
  faq: originalEn.faq,
  videoUsageHistory: originalEn.videoUsageHistory,
  contentVideoEditor: contentVideoEditorEn, // 새로운 분리된 contentVideoEditor 사용
  planDashboard: originalEn.planDashboard, // Plan 컴포넌트 번역 추가
  productVideoEditor: productVideoEditorEn, // 새로운 분리된 productVideoEditor 사용
  tiktok: tiktokEn, // 새로운 분리된 tiktok 사용
  auth: authEn, // 새로운 분리된 auth 사용
  challenge: challengeEn, // 새로운 분리된 challenge 사용
  payback: paybackEn, // 새로운 분리된 payback 사용
  freePlan: freePlanEn, // 새로운 분리된 freePlan 사용
  fastclick: fastclickEn, // 새로운 분리된 fastclick 사용
  guideToUse: guideToUseEn, // 새로운 분리된 guideToUse 사용
  videoTypes: videoTypesEn, // 새로운 분리된 videoTypes 사용
  footer: footerEn, // 새로운 분리된 footer 사용
}

export default {
  ko: koTranslations,
  en: enTranslations,
}